import { render, staticRenderFns } from "./assessment-panel--grid.vue?vue&type=template&id=63b54312&scoped=true&"
import script from "./assessment-panel--grid.vue?vue&type=script&lang=ts&"
export * from "./assessment-panel--grid.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-panel--grid.vue?vue&type=style&index=0&id=63b54312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b54312",
  null
  
)

export default component.exports